module.exports = __webpack_public_path__ + "media/images/icons/bar-chart-0a94e6d3e2c86cd0a89b35d6518ea95e.svg";